var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import './approval-phases-card.css';
import { Card, Link } from '@philips-internal/oswald-ui-components';
import { SelectionType, Size } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { eventListener, number, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { MessageService, ModelService } from '@philips-internal/oswald-ui-core/lib/services';
import { generateUUID, isFunction } from '@philips-internal/oswald-ui-utils';
import renderLegends from '../util/render-legends';
import ApprovalPhasesCardAPI from './approval-phases-card-api';
let ApprovalPhasesCard = class ApprovalPhasesCard extends Component {
    constructor() {
        super(...arguments);
        this.onClick = () => {
            const { onClick, note } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        note,
                    },
                }));
            }
        };
    }
    getSituation() {
        const { situation } = this.props;
        switch (situation) {
            case 'A':
                return MessageService.translate('approvals.filtered-list-approved-checkbox');
            case 'B':
                return MessageService.translate('approvals.filtered-list-settled-checkbox');
            case 'E':
                return MessageService.translate('approvals.filtered-list-forwarded-checkbox');
            case 'P':
                return MessageService.translate('approvals.filtered-list-pending-checkbox');
            default:
                return MessageService.translate('approvals.filtered-list-disapproved-checkbox');
        }
    }
    renderIndicator() {
        return (React.createElement("div", { className: "approval-phases-card__indicator" }, this.renderIndicatorColorStatus()));
    }
    renderIndicatorColorStatus() {
        const { situation } = this.props;
        switch (situation) {
            case 'A':
                return React.createElement("div", { className: "approval-phases-card__indicator-approved" });
            case 'B':
                return React.createElement("div", { className: "approval-phases-card__indicator-closed" });
            case 'E':
                return React.createElement("div", { className: "approval-phases-card__indicator-forwarded" });
            case 'P':
                return React.createElement("div", { className: "approval-phases-card__indicator-pending" });
            default:
                return React.createElement("div", { className: "approval-phases-card__indicator-disapproved" });
        }
    }
    render() {
        const { nmPerson, approvalDate, note, } = this.props;
        const approvalDateFmt = ModelService.format('date', approvalDate, { type: 'timestamp' });
        const situationDesc = this.getSituation();
        return (React.createElement(Card, { width: 12, transparent: false, className: "approval-phases-card", uuid: generateUUID(), selectionType: SelectionType.SINGLE, superscription: renderLegends() },
            this.renderIndicator(),
            React.createElement("div", { className: "approval-phases-card__info" },
                React.createElement("div", { className: "approval-phases-card__info-value" },
                    React.createElement("span", { className: "approval-phases-card__info-label" },
                        MessageService.translate('approvals.phases.person'),
                        ":"),
                    " ",
                    nmPerson),
                React.createElement("div", { className: "approval-phases-card__info-value" },
                    React.createElement("span", { className: "approval-phases-card__info-label" },
                        MessageService.translate('approvals.phases.situation'),
                        ":"),
                    " ",
                    situationDesc),
                React.createElement("div", { className: "approval-phases-card__info-value" },
                    React.createElement("span", { className: "approval-phases-card__info-label" },
                        MessageService.translate('approvals.phases.approval-date'),
                        ":"),
                    " ",
                    approvalDateFmt),
                note &&
                    (React.createElement("div", { className: "approval-phases-card__info-value" },
                        React.createElement(Link, { className: "approval-phases-card__info-link", value: MessageService.translate('approval.view.history'), size: Size.MEDIUM, onClick: () => this.onClick() }))))));
    }
};
ApprovalPhasesCard.propTypes = {
    sequenceApproval: number,
    nmPerson: string,
    situation: string,
    approvalDate: string,
    note: string,
    onClick: eventListener,
};
ApprovalPhasesCard = __decorate([
    AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: ApprovalPhasesCardAPI })
], ApprovalPhasesCard);
export default ApprovalPhasesCard;
//# sourceMappingURL=approval-phases-card.js.map